<template>
  <div ref="printSgf" class="print-sgf" :style="{width, transform}">
    <div class="info no-break">
      <div class="flex">
        <span>
          <img :src="Logo" class="logo inline-block" />
          <span class="text-12">HiGO 圍棋</span>
        </span>
        <div class="text-12 text-right flex-1">總譜：{{ totalStep }}</div>
      </div>
      <hr class="my-sm" />
      <div class="text-12 flex">
        <div class="flex-1">
          <div class="flex" style="gap: 0.25rem">
            <span class="font-bold">{{ tournamentName }}</span>
            <div class="m-1">|</div>
            <span>{{ gameName }}</span>
          </div>
          <div>黑方：{{ blackName }}</div>
          <div>白方：{{ whiteName }}</div>
          <div>貼目：{{ komi }}</div>
          <div>結果：{{ result }}</div>
          <div>日期：{{ time }}</div>
        </div>
        <div class="flex-3 text-right" style="padding-top: 40px;">
          <img
            width="50"
            height="50"
            class="border inline-block"
            :src="qrCodeImage"
          />
          <div class="text-12">立即下載 HiGO 圍棋</div>
        </div>
      </div>
    </div>
    <div class="board relative" :style="{width, height: this.width}">
      <div id="printBoard" style="visibility: hidden;"></div>
      <div class="bg-white">
        <img
          v-for="(src, index) of boardImages"
          :key="index"
          width="100%"
          height="100%"
          class="absolute top-0 left-0  z-modal"
          :src="src"
        />
      </div>
    </div>
    <canvas
      v-if="repeatStones.length"
      class="w-full no-break"
      ref="repeatStones"
    ></canvas>
  </div>
</template>

<script>
import Logo from '@/assets/img/logo-black.svg';
import WgoHelper from 'wgo-helper';
import {OBJECT_TYPE} from 'wgo.js';
import dayjs from 'dayjs';
import {parser} from 'goer-utils';
import _ from 'lodash';
import DEATH_STONE_SHOW_TYPES from '@/constant/deathStoneShowTypes.js';

export default {
  props: {
    qrCodeImage: {
      type: String,
      default: '',
    },
    kifu: {
      type: Object,
      default: () => {
        return {};
      },
    },
    type: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      Logo,
      boardImages: [],
      repeatStones: [],
      step: 0,
      wgoHelper: null,
      stoneType: OBJECT_TYPE.MONO,
      width: '600px',
      transform: 'translate(-50%, -50%)',
    };
  },
  computed: {
    sgf() {
      // 超多死子的棋譜
      // return `(;GM[1]FF[4]CA[UTF-8]AP[Sabaki:0.51.1]KM[6.5]SZ[19]DT[2024-04-16];B[aa];W[ab];B[ba];W[bb];B[ca];W[cb];B[db];W[da];B[eb];W[dc];B[cc];W[fc];B[ca];W[ba];B[bc];W[cd];B[ac];W[bd];B[ad];W[ae];B[ad];W[ac];B[bc];W[cc];B[ce];W[be];B[bf];W[cf];B[de];W[dd];B[ed];W[ec];B[gd];W[fd];B[fb];W[gc];B[ee];W[fe];B[ef];W[df];B[dg];W[cg];B[ag];W[af];B[bg];W[bh];B[ah];W[ai];B[ag];W[bg];B[ch];W[ah];B[dh];W[eg];B[ff];W[gf];B[ge];W[fg];B[ee];W[ef];B[de];W[ed];B[gb];W[ce];B[ea];W[fa];B[ga];W[ha];B[fa];W[hb];B[fb];W[db];B[eb];W[ca];B[ea];W[bc];B[fa];W[aa];B[gb];W[ad];B[ee];W[bf];B[bi];W[ag];B[ak];W[aj];B[bj];W[de];B[eh];W[ff];B[fh];W[ee];B[gg];W[gh];B[hf];W[he];B[hc];W[hd];B[ie];W[id];B[ic];W[jd];B[jc];W[je];B[kd];W[ke];B[jf];W[kf];B[kg];W[lf];B[le];W[ib];B[mf];W[ia];B[lg];W[jb];B[ja];W[ga];B[kb];W[aa];B[ab];W[ac];B[ba];W[bb];B[bc];W[aa];B[ad];W[ab];B[cb];W[ca];B[da];W[db];B[dc];W[aa];B[bb];W[ab];B[ac];W[ej];B[fk];W[em];B[dl];W[cn];B[co];W[do];B[dm];W[be];B[af];W[bg];B[bh];W[ah];B[ai];W[ag];B[aj];W[cg];B[cf];W[bf];B[ae];W[bd];B[cd];W[ce];B[cc];W[ab];B[aa];W[de];B[ab];W[dd];B[ca];W[ec];B[db];W[ga];B[fc];W[ha];B[hb];W[ia];B[ib];W[ga];B[ha];W[ed];B[df];W[ef];B[eg];W[fd];B[fg];W[la];B[ga];W[lb];B[gc];W[lc];B[ia];W[ka];B[jb];W[kc];B[ee];W[fe];B[hg];W[gf];B[ig];W[hd];B[jh];W[he];B[ih];W[id];B[hh];W[jd];B[kh];W[ae];B[aa];W[af];B[ab];W[ad];B[ac];W[ba];B[bb];W[bc];B[cb];W[cc];B[db];W[ca];B[eb];W[da];B[fb];W[ea];B[gb];W[fa];B[hb];W[ga];B[ib];W[ha];B[jb];W[ia];B[kb];W[ja];B[dc];W[cd];B[fc];W[gc];B[hc];W[ic];B[gd];W[ge];B[jc];W[gc];B[je];W[ff];B[if];W[ee];B[jg];W[gd];B[ke];W[jc];B[kf];W[hc];B[lf];W[fc];B[ci];W[dc];B[di];W[ac];B[ei];W[aa];B[fi];W[ab];B[ma];W[kb];B[nb];W[hb];B[mb];W[jb];B[mc];W[ib];B[ld];W[gb];B[fb];W[eb];B[db];W[fb];B[cb];W[bb];B[cb];W[db];B[cb];W[aa];B[ab];W[ba];B[bb];W[ca];B[da];W[aa];B[ba];W[gf];B[ff];W[fe];B[ge];W[he];B[id];W[jd];B[jc];W[kc];B[lc];W[lb];B[kb];W[ic];B[hc];W[hd];B[gd];W[gc];B[hd];W[fd];B[he];W[fc];B[hb];W[jb];B[ib];W[ia];B[ja];W[la];B[ka];W[ha];B[ga];W[gb];B[fa];W[fb];B[eb];W[ec];B[ed];W[ee])`;
      // 不少死子的棋譜
      // return '(;GM[1]FF[4]CA[UTF-8]AP[Sabaki:0.51.1]KM[6.5]SZ[19]DT[2024-04-16];B[aa];W[ab];B[ba];W[bb];B[ca];W[cb];B[db];W[da];B[eb];W[dc];B[cc];W[fc];B[ca];W[ba];B[bc];W[cd];B[ac];W[bd];B[ad];W[ae];B[ad];W[ac];B[bc];W[cc];B[ce];W[be];B[bf];W[cf];B[de];W[dd];B[ed];W[ec];B[gd];W[fd];B[fb];W[gc];B[ee];W[fe];B[ef];W[df];B[dg];W[cg];B[ag];W[af];B[bg];W[bh];B[ah];W[ai];B[ag];W[bg];B[ch];W[ah];B[dh];W[eg];B[ff];W[gf];B[ge];W[fg];B[ee];W[ef];B[de];W[ed];B[gb];W[ce];B[ea];W[fa];B[ga];W[ha];B[fa];W[hb];B[fb];W[db];B[eb];W[ca];B[ea];W[bc];B[fa];W[aa];B[gb];W[ad];B[ee];W[bf];B[bi];W[ag];B[ak];W[aj];B[bj];W[de];B[eh];W[ff];B[fh];W[ee];B[gg];W[gh];B[hf];W[he];B[hc];W[hd];B[ie];W[id];B[ic];W[jd];B[jc];W[je];B[kd];W[ke];B[jf];W[kf];B[kg];W[lf];B[le];W[ib];B[mf];W[ia];B[lg];W[jb];B[ja];W[ga];B[kb];W[aa];B[ab];W[ac];B[ba];W[bb];B[bc];W[aa];B[ad];W[ab];B[cb];W[ca];B[da];W[db];B[dc];W[aa];B[bb];W[ab];B[ac];W[ej];B[fk];W[em];B[dl];W[cn];B[co];W[do];B[dm];W[be];B[af];W[bg];B[bh];W[ah];B[ai];W[ag];B[aj];W[cg];B[cf];W[bf];B[ae];W[bd];B[cd];W[ce];B[cc];W[ab];B[aa];W[de];B[ab];W[dd];B[ca];W[ec];B[db];W[ga];B[fc];W[ha];B[hb];W[ia];B[ib];W[ga];B[ha];W[ed];B[df];W[ef];B[eg];W[fd];B[fg];W[la];B[ga];W[lb];B[gc];W[lc];B[ia];W[ka];B[jb];W[kc];B[ee];W[fe];B[hg];W[gf];B[ig];W[hd];B[jh];W[he];B[ih];W[id];B[hh];W[jd];B[kh];W[ae];B[aa];W[af];B[ab];W[ad];B[ac];W[ba];B[bb];W[bc];B[cb];W[cc];B[db];W[ca];B[eb];W[da];B[fb];W[ea];B[gb];W[fa];B[hb];W[ga];B[ib];W[ha];B[jb];W[ia];B[kb];W[ja];B[dc];W[cd];B[fc];W[gc];B[hc];W[ic];B[gd];W[ge];B[jc];W[gc];B[je];W[ff];B[if];W[ee])';
      // 一些死子的棋譜
      // return '(;GM[1]FF[4]CA[UTF-8]AP[Sabaki:0.51.1]KM[6.5]SZ[19]DT[2024-04-16];B[aa];W[ab];B[ba];W[bb];B[ca];W[cb];B[db];W[da];B[eb];W[dc];B[cc];W[fc];B[ca];W[ba];B[bc];W[cd];B[ac];W[bd];B[ad];W[ae])';
      return this.kifu?.sgf;
    },
    blackName() {
      return this.kifu?.blackPlayer?.name || '-';
    },
    whiteName() {
      return this.kifu?.whitePlayer?.name || '-';
    },
    komi() {
      const komi = parseFloat(this.kifu?.komi);
      if (isNaN(komi)) return '';
      const color = komi >= 0 ? '黑' : '白';
      const intKomi = parseInt(komi);
      const deltaKomi = komi - intKomi;
      if (deltaKomi >= 0.01 && deltaKomi <= 0.9) {
        return `${color}${intKomi}目半`;
      } else {
        return `${color}${komi}目`;
      }
    },
    result() {
      let result = `${this.step}手`;
      if (this.kifu.winningWay) {
        result += ` ${this.kifu.winningWay}`;
      }
      return result;
    },
    time() {
      const gameStartedAt = this.kifu?.gameStartedAt;
      if (gameStartedAt) {
        return dayjs(gameStartedAt).format('YYYY-MM-DD');
      }
      return '-';
    },
    tournamentName() {
      const tournamentName = this.kifu?.tournamentName;
      const seriesTournamentName = this.kifu?.series?.tournament?.name;
      return tournamentName || seriesTournamentName || '-';
    },
    gameName() {
      const seriesName = this.kifu?.series?.name;
      return seriesName || '-';
    },
    totalStep() {
      return this.step ? `1~${this.step}` : '0';
    },
    deathStoneShowType() {
      return (
        DEATH_STONE_SHOW_TYPES[this.type] || DEATH_STONE_SHOW_TYPES.HAIFONG
      );
    },
  },
  watch: {
    sgf() {
      this.initBoard();
    },
    async repeatStones() {
      await this.$nextTick();
      this.initRepeatStoneCanvas();
    },
  },
  mounted() {
    this.initBoard();
  },
  methods: {
    initBoard() {
      if (this.wgoHelper) return;
      if (!this.sgf) return;
      const r = this.sgf.match(/SZ\[([0-9]+)\]/);
      const size = r ? parseInt(r[1]) : 19;
      const sgfContents = this.sgf.split(';');
      this.wgoHelper = new WgoHelper('game', 'printBoard', `(;SZ[${size}])`, {
        theme: {
          stoneHandler: this.stoneType,
          strokeColor: 'black',
          blackStoneColor: 'black',
          whiteStoneColor: 'white',
          markupBlackColor: 'white',
          markupWhiteColor: 'black',
        },
      });
      this.wgoHelper.toggleCoordinates(false);
      this.drawBoardAndSetRepeatStones(sgfContents, size);
    },
    initRepeatStoneCanvas() {
      if (!this.wgoHelper) return;
      switch (this.deathStoneShowType) {
        case DEATH_STONE_SHOW_TYPES.NORMAL: {
          return this.drawNormalRepeatStoneCanvas();
        }
        case DEATH_STONE_SHOW_TYPES.HAIFONG: {
          return this.drawHaifongRepeatStoneCanvas();
        }
      }
    },
    drawNormalRepeatStoneCanvas() {
      if (!this.wgoHelper) return;
      const canvas = this.$refs['repeatStones'];
      if (!canvas) return;
      const board = this.wgoHelper.editable.board;
      const pixelRatio = window.devicePixelRatio;
      const stoneRadius = board.stoneRadius * 2;
      const drawHandlers = window.WGo.Board.drawHandlers;
      const stoneDrawHandlers = drawHandlers[this.stoneType];
      const lbDrawHandlers = drawHandlers[OBJECT_TYPE.LB];
      const padding = {
        top: 45 * pixelRatio,
        left: 60 * pixelRatio,
        right: 60 * pixelRatio,
        bottom: 15 * pixelRatio,
      };
      const xCount = parseInt(
        (board.width - padding.left - padding.right) / stoneRadius / 2,
      );
      const yCount = Math.ceil(this.repeatStones.length / xCount);
      canvas.width = board.width;
      canvas.height =
        stoneRadius * 1.4 * yCount + padding.left + padding.bottom;
      const gridWidth =
        (canvas.width - padding.left - padding.right) / Math.max(xCount - 1, 1);
      const gridHeight =
        (canvas.height - padding.top - padding.bottom) / Math.max(yCount, 1);
      const customStoneBoard = {
        getX: (x) => {
          return padding.left + x * gridWidth - stoneRadius / 2;
        },
        getY: (y) => {
          return padding.top + y * gridHeight - stoneRadius / 2;
        },
        stoneRadius: board.stoneRadius,
        theme: board.theme,
      };
      const ctx = canvas.getContext('2d');
      this.repeatStones.forEach((stone, index) => {
        const {c, step, color} = stone;
        const y = parseInt(index / xCount);
        const x = index % xCount;
        stoneDrawHandlers.stone.draw.call(ctx, {x, y, c}, customStoneBoard);
        lbDrawHandlers.stone.draw.call(
          ctx,
          {
            x,
            y,
            c:
              color === 'black'
                ? board.theme.markupBlackColor
                : board.theme.markupWhiteColor,
            text: `${step}`,
          },
          customStoneBoard,
        );
        lbDrawHandlers.stone.draw.call(
          ctx,
          {
            x: x + 0.45,
            y,
            c: board.theme.markupWhiteColor,
            text: stone.board,
          },
          customStoneBoard,
        );
      });
      this.setPrintSize();
    },
    drawHaifongRepeatStoneCanvas() {
      if (!this.wgoHelper) return;
      const groupByOriginStone = {};
      this.repeatStones.forEach((repeatStone) => {
        const {originStone, step, c} = repeatStone;
        const originStep = originStone.step;
        if (!groupByOriginStone[originStep]) {
          groupByOriginStone[originStep] = {
            originStep,
            originC: originStone.c,
            stones: [],
          };
        }
        groupByOriginStone[originStep].stones.push({
          step,
          c,
        });
      });
      const canvas = this.$refs['repeatStones'];
      if (!canvas) return;
      const board = this.wgoHelper.editable.board;
      canvas.width = board.width;
      canvas.height = 290;
      const pixelRatio = 1.666; // Change to 1 on retina screens to see blurry canvas.
      canvas.width = Math.floor(canvas.width * pixelRatio);
      canvas.height = Math.floor(canvas.height * pixelRatio);
      const padding = {
        top: 0 * pixelRatio,
        left: 0 * pixelRatio,
        right: 0 * pixelRatio,
        bottom: 20 * pixelRatio,
      };
      const drawWidth = canvas.width - padding.left - padding.right;
      const drawHeight = canvas.height - padding.top - padding.bottom;
      const drawArea = drawWidth * drawHeight;
      const length = Object.values(groupByOriginStone).reduce(
        (pre, {stones}) => {
          return pre + 2 + stones.length;
        },
        0,
      );

      const stoneArea = drawArea / length;
      const stoneRadius = Math.min(
        (Math.sqrt(stoneArea) / 2) * pixelRatio,
        board.stoneRadius * pixelRatio,
      );

      const drawHandlers = window.WGo.Board.drawHandlers;
      const stoneDrawHandlers = drawHandlers[this.stoneType];
      const lbDrawHandlers = drawHandlers[OBJECT_TYPE.LB];

      const xCount = Math.ceil(drawWidth / stoneRadius / 2);
      const yCount = Math.ceil(length / xCount) + 1;
      const gridWidth = drawWidth / Math.max(xCount, 1) / pixelRatio;
      const gridHeight = Math.min(
        drawHeight / Math.max(yCount, 1) / pixelRatio,
        stoneRadius * 1.4,
      );
      const customStoneBoard = {
        getX: (x) => {
          return padding.left + x * gridWidth + stoneRadius / 2;
        },
        getY: (y) => {
          return padding.top + y * gridHeight + stoneRadius / 2;
        },
        stoneRadius: stoneRadius / 2,
        theme: board.theme,
      };
      const ctx = canvas.getContext('2d');
      ctx.scale(pixelRatio, pixelRatio);
      let index = -1;
      _.sortBy(Object.values(groupByOriginStone), 'originStep').forEach(
        ({originStep, originC, stones}) => {
          let originY = null;
          const drawOriginStone = () => {
            index = index + 1;
            let y = parseInt(index / xCount);
            const nexStoneY = parseInt((index + 2) / xCount);
            if (y !== nexStoneY) {
              index = xCount * (y + 1);
            }
            y = parseInt(index / xCount);
            const x = index % xCount;
            const c = originC;
            originY = y;
            stoneDrawHandlers.stone.draw.call(ctx, {x, y, c}, customStoneBoard);
            lbDrawHandlers.stone.draw.call(
              ctx,
              {
                x,
                y,
                c:
                  originC > 0
                    ? board.theme.markupBlackColor
                    : board.theme.markupWhiteColor,
                text: `${originStep}`,
              },
              customStoneBoard,
            );
            lbDrawHandlers.stone.draw.call(
              ctx,
              {
                x: x + 0.7,
                y,
                c: board.theme.markupWhiteColor,
                text: '－',
              },
              customStoneBoard,
            );
            index = index + 1;
          };
          drawOriginStone();
          stones.forEach(({step, c}) => {
            index = index + 1;
            let y = parseInt(index / xCount);
            if (y !== originY) {
              index = index - 1;
              drawOriginStone();
              index = index + 1;
            }
            y = parseInt(index / xCount);
            const x = (index % xCount) - 0.6;
            stoneDrawHandlers.stone.draw.call(ctx, {x, y, c}, customStoneBoard);
            lbDrawHandlers.stone.draw.call(
              ctx,
              {
                x,
                y,
                c:
                  c > 0
                    ? board.theme.markupBlackColor
                    : board.theme.markupWhiteColor,
                text: `${step}`,
              },
              customStoneBoard,
            );
          });
        },
      );
      this.setPrintSize();
    },
    getMoves(sgfContents) {
      const moves = [];
      sgfContents.forEach((content, index) => {
        const blackReq = /(AB|B)(\[[^A-Z]+\])/g;
        const whiteReq = /(AW|W)(\[[^A-Z]+\])/g;
        const blackStones = content.match(blackReq);
        const whiteStones = content.match(whiteReq);
        const moveReq = /[a-z]+/g;
        const moveStones = [];
        const setMoves = (stones, c) => {
          if (stones) {
            stones.forEach((stone) => {
              const result = stone.match(moveReq);
              if (result) {
                result.forEach((sgfMove) => {
                  const step = index - 1;
                  const color = c > 0 ? 'black' : 'white';
                  const {x, y} = parser.sgfToNumber(sgfMove);
                  const board = parser.sgfToBoard(sgfMove);
                  moveStones.push({x, y, board, c, color, step});
                  this.step = step;
                });
              }
            });
          }
        };
        setMoves(blackStones, 1);
        setMoves(whiteStones, -1);
        if (moveStones.length) moves.push(moveStones);
      });
      return moves;
    },
    drawBoardAndSetRepeatStones(sgfContents, size) {
      const moves = this.getMoves(sgfContents);
      const grid = _.map(new Array(size), () => new Array(size));
      const repeatStones = [];
      moves.forEach((stones) => {
        stones.forEach((stone) => {
          const {x, y} = stone;
          if (grid[x][y]) {
            repeatStones.push({originStone: grid[x][y], ...stone});
          } else {
            grid[x][y] = stone;
          }
        });
      });
      const theme = this.wgoHelper.editable.board.theme;
      grid.forEach((row) => {
        row.forEach((stone) => {
          this.wgoHelper.addSetup(stone);
        });
      });
      grid.forEach((row) => {
        row.forEach((stone) => {
          const {x, y, color, step} = stone;
          this.wgoHelper.addObject({
            x,
            y,
            type: 'LB',
            text: `${step}`,
            c:
              color === 'black'
                ? theme.markupBlackColor
                : theme.markupWhiteColor,
          });
        });
      });
      const canvasList = this.wgoHelper.editable.board.element.children;
      this.boardImages = _.map(canvasList, (canvas) => canvas.toDataURL());
      this.repeatStones = repeatStones;
    },
    print() {
      const el = this.$el;
      const parent = el.parentNode;
      const nextSibling = el.nextSibling;

      document.body.appendChild(el);

      let restored = false;
      const restore = () => {
        if (restored) return;
        restored = true;
        if (nextSibling) {
          parent.insertBefore(el, nextSibling);
        } else {
          parent.appendChild(el);
        }
      };

      window.addEventListener('afterprint', restore, {once: true});
      window.print();
    },
    setPrintSize() {
      // 怕之後復活, 先留者
      // const printSgf = this.$refs.printSgf;
      // const {clientWidth, clientHeight} = printSgf;
      // const a4Height = (29.7 * clientWidth) / 21;
      // if (clientHeight > a4Height) {
      //   const scale = (a4Height / clientHeight) * 1.4;
      //   this.transform = `translate(-50%, 0%) scale(${scale})`;
      // }
    },
  },
};
</script>

<style scoped lang="scss">
.print-sgf {
  display: block;
  position: absolute;
  left: -9999px;
  top: 0;
  background: white;
  z-index: -999999;
  visibility: hidden;
  // z-index: 999999;
  // top: 0;
  .logo {
    height: 14px;
    margin: -2px 5.3px 0 0;
  }
  #printBoard {
    width: 100%;
    height: 100%;
  }
}
</style>

<style>
@page {
  size: A4 portrait;
  margin: 0cm;
}
@media print {
  html,
  body {
    height: auto !important;
    min-height: 0 !important;
  }
  body > *:not(.print-sgf) {
    display: none !important;
  }
  body > .print-sgf {
    display: block !important;
    position: relative !important;
    left: auto !important;
    top: auto !important;
    width: 80% !important;
    margin: 3% auto 0 !important;
    visibility: visible !important;
    background: white !important;
    transform: none !important;
    z-index: auto !important;
    overflow: visible !important;
  }
  body > .print-sgf * {
    visibility: visible !important;
  }
  body > .print-sgf #printBoard {
    display: none !important;
  }
  body > .print-sgf .board {
    position: relative !important;
    width: 100% !important;
    height: auto !important;
    overflow: hidden !important;
    padding: 50% !important;
  }
  body > .print-sgf .board > * {
    position: absolute !important;
    top: 0 !important;
    left: 0 !important;
    width: 100% !important;
    height: 100% !important;
  }
  body > .print-sgf .no-break {
    page-break-inside: avoid !important;
    break-inside: avoid !important;
  }
}
</style>
